

import axios from "axios"
const notaryService={}
notaryService.createOrder= async (orderObject)=>{
    const config={
         url:`https://inheritguard.onrender.com/snapdocs/v1/createNotaryOrder`,
        // url:`http://localhost:5000/snapdocs/v1/createNotaryOrder`,
         method:"post",
         data:orderObject
       }
      
     return axios(config)
   
      
   }



  export default notaryService